import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=00465d7a&scoped=true"
import script from "./customer-list.vue?vue&type=script&lang=js"
export * from "./customer-list.vue?vue&type=script&lang=js"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=00465d7a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00465d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00465d7a')) {
      api.createRecord('00465d7a', component.options)
    } else {
      api.reload('00465d7a', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=00465d7a&scoped=true", function () {
      api.rerender('00465d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/specialty_store_update/form/customer-list.vue"
export default component.exports